import Link from 'next/link'

import exploreEvents from '@/utils/gaEvents/exploreEvents'

import Icons from '@/shared/components/icon/Icons'
import type { SlideItem } from '@/shared/components/slider/view'
import { Caption, Tint } from '@/shared/components/typography'
import useHash from '@/shared/hooks/useHash'

import { SHEET_STATE_TYPE } from '@/enums/detail'
interface ParkinglotCardProps {
  item: SlideItem
}

const ParkinglotCard = ({ item }: ParkinglotCardProps) => {
  const { updateHash } = useHash()
  const hash = updateHash({ sheet: SHEET_STATE_TYPE.VISIBLE })
  const isParkinglot = 'parkinglotSeq' in item
  const handleExploreEvent = () => {
    if (isParkinglot) {
      exploreEvents.common.onClickRecommendParkinglotCard(item.tickets[0].couponSeq, item.parkinglotSeq)
    }
  }
  return (
    <div className="relative flex w-[205px] flex-col gap-1 rounded-md border border-030 p-4">
      <Link
        href={`/map?type=P&id=${isParkinglot && item.parkinglotSeq}${hash}`}
        key={isParkinglot ? item.parkinglotSeq : 0}
        onClick={handleExploreEvent}
        replace
        className="flex flex-col gap-[4px]"
      >
        <div className="w-[164px]">
          <Caption
            level="caption1"
            weight="bold"
            color="text090"
            className="inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap align-middle"
          >
            {isParkinglot ? item.name : '-'}
          </Caption>
        </div>
        <div className="flex w-full items-center">
          <Tint level="tint1" weight="regular" className="text-gray-060">
            {isParkinglot && item.qty ? `${item.qty.toLocaleString()}면` : '정보없음'}
          </Tint>
          <div className="mb-[2px] h-[12px] w-[12px]">
            <Icons.BulletIcon fill="currentColor" color="#6D7D90" />
          </div>
          <Tint level="tint1" weight="regular" className="text-gray-060">
            {isParkinglot && `${'distance' in item && item.distance.toLocaleString()}m`}
          </Tint>
        </div>
        <div className="flex w-full items-center">
          <Caption
            level="caption2"
            weight="medium"
            color="main050"
            className="inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap align-middle"
          >
            {isParkinglot && item.tickets.length === 1
              ? `${item.tickets[0].couponName} ${item.tickets[0].price.toLocaleString()}원`
              : isParkinglot &&
                `${item.tickets[0].couponName} ${item.tickets[0].price.toLocaleString()}원 외 ${
                  item.tickets.length - 1
                }개`}
          </Caption>
        </div>
      </Link>
    </div>
  )
}

export default ParkinglotCard
